import styles from "./styles.module.scss";
import Modal from "@mui/material/Modal/Modal";
import Button from "@mui/material/Button/Button";
import closeIconModal from "./../../../../assets/_CloseIconModal_.svg";
import { useEffect, useState } from "react";
import { getProjectBudgetHistory } from "../../../../services/api/ProjectBudget/ProjectBudgetService";
import dayjs from "dayjs";
import { IProjectBudgetHistory, IProjectBudgetHistoryPage } from "../../../../@types/project/project-budget.type";
import { IApiResponse } from "../../../../@types/api-response.type";
import TimelineItem from "@mui/lab/TimelineItem/TimelineItem";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent/TimelineOppositeContent";
import TimelineSeparator from "@mui/lab/TimelineSeparator/TimelineSeparator";
import TimelineDot from "@mui/lab/TimelineDot/TimelineDot";
import TimelineConnector from "@mui/lab/TimelineConnector/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent/TimelineContent";
import Timeline from "@mui/lab/Timeline/Timeline";
import timelineOppositeContentClasses from "@mui/lab/TimelineOppositeContent/timelineOppositeContentClasses";


interface AddContractedPerfilProps {
  openModal: boolean,
  handleCloseModal: () => void,
  projectId: string,
  id: string,
}

export const HistoryHiredModal: React.FC<AddContractedPerfilProps> = ({openModal, handleCloseModal, projectId}) => { 
  const [history, setHistory] = useState<IProjectBudgetHistoryPage>();

  const loadDomainData = async () => {
    try {
      const response = (await getProjectBudgetHistory(projectId, 0, 10))  as IApiResponse<IProjectBudgetHistoryPage>;
      setHistory(response.result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    loadDomainData();
  }, []);

  function GetTimeline(items: IProjectBudgetHistory[]){
    let component = [];
    for (let index = 0; index < items?.length; index++) {
      const element = items[index];
      component.push(<>
        <TimelineItem>
          <TimelineOppositeContent color="text.secondary">
            {dayjs(element.createdAt).format("YYYY-MM-DD HH:mm:ss")}
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot />
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>{element.action}</TimelineContent>
        </TimelineItem>
      </>)
      
    }
    return component;
  }
  
  return (
    <Modal open={openModal} onClose={handleCloseModal}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h3>Historico de Alteração</h3>
          <Button onClick={handleCloseModal} className={styles.iconButton}>
            {closeIconModal && <img src={closeIconModal} />}
          </Button>
        </div>
        <div className={styles.container}>
          <Timeline
            sx={{
              [`& .${timelineOppositeContentClasses.root}`]: {
                flex: 0.2,
              },
            }}
          >
            {history && GetTimeline(history.items)}
          </Timeline>
        </div>
      </div>
    </Modal>
  );
};
